import { useRecoilState } from "recoil";
import Flex from "../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../Filters/DropDown";
import Search from "../../Filters/Search";
import { PartyInfoFilterContainer } from "../Party/PartyInfo/PartyInfoFilter";
import React, { useState, useEffect } from "react";
import { newUserLogFilterState } from "../../../pages/NewUserLog/NewUserLog";
import ConfirmBtn from "../../Button/ConfirmBtn";
import LineBtn from "../../Button/LineBtn";
import { ActLog } from "../../../Enum/state.Enum";

interface NewUserLogFilterProps {
  pageResetEvent: () => void;
}

const userFilterOption = [
  { value: "uid", label: "UID" },
  { value: "name", label: "이름" },
  { value: "nickname", label: "닉네임" },
  { value: "partyid", label: "PID" },
];

export default function NewUserLogFilter({
  pageResetEvent,
}: NewUserLogFilterProps) {
  const [filter, setFilter] = useRecoilState(newUserLogFilterState);
  const [logTypeOption, setLogTypeOption] = useState<OptionType[]>([]);

  const [filterType, setFilterType] = useState({
    value: filter?.searchType !== "" ? filter?.searchType : "",
    label:
      filter?.searchType !== ""
        ? userFilterOption?.find((u) => u.value === filter?.searchType)?.label
        : "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>(
    filter?.searchValue !== "" ? filter?.searchValue : ""
  );

  const [startDate, setStartDate] = useState("날짜 선택");
  const [startDateClick, setStartDateClick] = useState(false);

  const [endDate, setEndDate] = useState("날짜 선택");
  const [endDateClick, setEndDateClick] = useState(false);

  const [logType, setLogType] = useState({
    value: filter?.logType !== "" ? filter?.logType : "",
    label: filter?.logType !== "" ? "" : "로그 타입 선택 ",
  });

  useEffect(() => {
    if (searchValue && searchValue?.length > 0) {
      setFilter((prev) => ({
        ...prev,
        searchType: filterType?.value,
        searchValue: `${searchValue}`,
      }));
    }
  }, [searchValue]);

  useEffect(() => {
    const entries = Object.entries(ActLog);

    const optionList: { value: string; label: string }[] = [];

    entries?.forEach((e) => {
      optionList.push({
        value: e[0],
        label: e[1],
      });
    });

    if (optionList?.length > 0) {
      setLogTypeOption(optionList);
    }
  }, []);

  return (
    <>
      <PartyInfoFilterContainer maxWidth={1200}>
        <Flex gapSize={10}>
          <DropDown
            boxWidth={160}
            optionList={userFilterOption}
            dropdownValue={filterType}
            setDropDownValue={setFilterType}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            pageResetEvent={() => pageResetEvent()}
            defaultValue={
              filter?.searchValue !== "" ? filter?.searchValue : undefined
            }
            isDisabled={filterType?.value === ""}
          />
        </Flex>

        <Flex gapSize={10}>
          <DropDown
            dropdownValue={logType}
            setDropDownValue={setLogType}
            optionList={logTypeOption}
          />

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={logType?.value === ""}
            btnClickEvent={() => {
              setFilter((prev) => ({
                ...prev,
                logType: logType?.value,
              }));
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={logType?.value === ""}
            btnClickEvent={() => {
              setLogType({
                value: "",
                label: "로그 타입 선택",
              });

              setFilter((prev) => ({
                ...prev,
                logType: "",
              }));
            }}
          />
        </Flex>
      </PartyInfoFilterContainer>
    </>
  );
}
